module.exports = __webpack_public_path__ + "static/img/Hguanli-2.945b01e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Hguanli-2.png
// module id = voqw
// module chunks = 1